import { Carousel, CarouselSlide } from '@vp/swan';
import { SupportedLocale, __ } from '@99designs/i18n';
import { ProductTile } from '../ProductTile';
import type { NavigationTracking } from '@99designs/tracking';
import type { DesignProductPresenter } from '../../../products/types';

interface ProductCarouselProps {
    products: DesignProductPresenter[];
    locale: SupportedLocale;
    productClickedTrackingData?: (
        product: DesignProductPresenter,
        index: number
    ) => NavigationTracking;
    maxSlides?: number;
    SeeAllTile?: React.ReactNode;
}

export function ProductCarousel({
    products,
    locale,
    productClickedTrackingData,
    maxSlides = 4,
    SeeAllTile,
}: ProductCarouselProps) {
    return (
        <Carousel
            slidesToShow={{ xs: 2, sm: 4, lg: maxSlides }}
            slidesToScroll={2}
            infinite={false}
            gridGutters
            accessibleTextForPrevious={__('Go to previous slide')}
            accessibleTextForNext={__('Go to next slide')}
            arrowVerticalOffset="-17px"
        >
            {products.map((product, index) => (
                <CarouselSlide key={product.key} data-testid="product-carousel-slide">
                    <ProductTile
                        key={product.key}
                        title={product.translatedTitle()}
                        imageSrc={product.previewImage({ cloudinaryOptions: { width: 450 } }).url}
                        imageAspectRatio={
                            product.previewImage({ cloudinaryOptions: { width: 450 } }).aspectRatio
                        }
                        ctaLink={product.ctaUrl(locale)}
                        trackingData={
                            productClickedTrackingData
                                ? productClickedTrackingData(product, index)
                                : undefined
                        }
                    />
                </CarouselSlide>
            ))}
            {SeeAllTile && (
                <CarouselSlide key="see-all" data-testid="product-carousel-slide">
                    {SeeAllTile}
                </CarouselSlide>
            )}
        </Carousel>
    );
}
